const doctorateData = [
  {
    campus: 'UCSF',
    'Average number of years': 6.0,
  },
  {
    campus: 'UC Berkeley',
    'Average number of years': 5.9,
  },
  {
    campus: 'UCLA',
    'Average number of years': 5.8,
  },

  {
    campus: 'UCSC',
    'Average number of years': 5.8,
  },

  {
    campus: 'UCSB',
    'Average number of years': 5.7,
  },
  {
    campus: 'UCSD',
    'Average number of years': 5.7,
  },
  {
    campus: 'UC Davis',
    'Average number of years': 5.6,
  },
  {
    campus: 'UC Irvine',
    'Average number of years': 5.3,
  },
  {
    campus: 'UC Riverside',
    'Average number of years': 5.3,
  },
  {
    campus: 'UC Merced',
    'Average number of years': 5.2,
  },
];

export default doctorateData;
